import { useTranslation } from 'react-i18next'
import { CurecallInput } from '@honestica/curecall-ui'

export type TDelayState = { days: number; hours: number; minutes: number }

interface DurationInputFieldsProps {
  delay: TDelayState
  onDelayChange: (delay: TDelayState) => void
}

export function DurationInputFields({ delay, onDelayChange }: DurationInputFieldsProps) {
  const { t } = useTranslation()

  return (
    <div className="c-flex c-gap-4 c-items-end">
      <CurecallInput
        label={t('pages.configuration.followups.chatbot.general-form.duration-unit-days')}
        placeholder="0"
        value={delay.days.toString()}
        onChange={(event) =>
          onDelayChange({ ...delay, days: Math.max(0, Number.parseInt(event.target.value) || 0) })
        }
        type="number"
        wrapperClassName="c-w-20"
        labelClassName="tw-mb-0.5"
      />
      <CurecallInput
        label={t('pages.configuration.followups.chatbot.general-form.duration-unit-hours')}
        placeholder="0"
        value={delay.hours.toString()}
        onChange={(event) =>
          onDelayChange({ ...delay, hours: Math.max(0, Number.parseInt(event.target.value) || 0) })
        }
        type="number"
        wrapperClassName="c-w-20"
        labelClassName="tw-mb-0.5"
      />
      <CurecallInput
        label={t('pages.configuration.followups.chatbot.general-form.duration-unit-minutes')}
        placeholder="0"
        value={delay.minutes.toString()}
        onChange={(event) =>
          onDelayChange({ ...delay, minutes: Math.max(0, Number.parseInt(event.target.value) || 0) })
        }
        type="number"
        wrapperClassName="c-w-20"
        labelClassName="tw-mb-0.5"
      />
    </div>
  )
}
